<template>
  <div class="wrap regular-list m-background">
    <div class="main-content" v-show="!subRouter.show">
      <Alert show-icon banner v-if="config.tableConfig&&config.tableConfig.comment"
             style="width:calc(100%-20px);margin:0 10px 10px 10px">{{config.tableConfig.comment}}
      </Alert>
      <div class="query-array">
        <div class="left-query">
          <query-obj
            v-for='(searchQuery, queryIndex) in config.queryList'
            v-show="!searchQuery.hidden && (moreFilter || queryIndex < 2*gridNumber)"
            :key='searchQuery.name'
            :search='searchQuery'
            @setSearchValueChange='setSearchValueChange'
            @clearSearchValueChange="clearSearchValueChange"
            @enterSearch="enterSearch"
          >
          </query-obj>
        </div>
        <div class="right-oper hidden-xs" style="width:150px">
          <Button v-if="config.queryList && config.queryList.length>0" type="primary" @click="enterSearch()"
                  style="margin-right:10px">查询
          </Button>
          <Button v-if="config.queryList && config.queryList.length>0" type="default" @click="refresh()">重置</Button>
          <Button v-if="config.queryList.length>2*gridNumber" type="text" style="margin-top: 10px;width: 124px;" @click="moreFilter=!moreFilter">{{moreFilter?'收起':'更多'}}筛选条件</Button>
        </div>
      </div>
      <div class="action-array" v-if="config.operList.length>0">
        <Button v-for="oper in config.operList"
                v-if="oper.show&&(permission.flag&&permission.buttons.includes(oper.name)||!permission.flag)"
                :key="oper.name"
                type="primary"
                @click="clickOperBtn(JSON.parse(JSON.stringify(oper)))"
        >{{oper.label}}
        </Button>
      </div>
      <div class="query-result">
        <Alert v-if="config.titles.length===0" type="error" show-icon>
          页面配置文件不存在
        </Alert>
        <query-table
          :loading="loading"
          :head-config="config.titles"
          :legent="config.legent||[]"
          :min-width="config.tableConfig&&config.tableConfig.minWidth||0"
          :show-checkbox="(config.tableConfig&&config.tableConfig.showCheckbox)||false"
          :checkbox-filter="(config.tableConfig&&config.tableConfig.checkboxFilter)||''"
          :rows="rows"
          :pager="page"
          :table-style="(config.tableConfig&&config.tableConfig.tableStyle)||''"
          :permission="permission"
          @clickTableBtn="clickOperBtn"
          @changePage="changePage"
          @onSelect="handleTableSelect"
        ></query-table>
      </div>
    </div>
    <div class="sub-content" v-if="subRouter.show">
      <component
        :ref="subComponent"
        :is="subComponent"
        :query="subRouter.query"
        @back="backMain"
      ></component>
    </div>
    <Modal
      v-model="dialogConfig.show"
      :title="dialogConfig.title"
      :loading="dialogConfig.loading"
      :fullscreen="dialogConfig.fullscreen"
      :width="dialogConfig.width"
      :footer-hide="dialogConfig.footerHide"
      @on-ok="dialogOK"
    >
      <component v-if="dialogConfig.show"
                 :ref="dialogComponent"
                 :is="dialogComponent"
                 :query="dialogConfig.query"
                 @fetchTableList="fetchTableList"
                 @reload="reload"
      ></component>
    </Modal>
  </div>
</template>

<script>
/* global Vue:true */
import PathConfig from './config'
import QueryObj from '@/components/regularQuery/queryObj.vue'
import QueryTable from '@/components/table/regularTable.vue'

const importDialogCustom = file => require('@/layout/dialogs/' + file + '.vue').default
const importSubCustom = file => require('@/layout/customPage/' + file + '.vue').default
export default {
  components: {QueryObj, QueryTable},
  props: {
    configPath: '',
    parentId: '',
    defaultQuery: {},
    permission: {} // {flag: true, // 是否控制资源 mapButton: [] // 资源列表}
  },
  data () {
    return {
      path: '',
      config: '',
      loading: false,
      tableSelectionIds: [], // 列表存在多选框时有效，可以在配置中使用{tableSelectionIds}来获取当前选中的id数组
      searchParam: {},
      rows: [],
      page: {
        show: false,
        total: 0,
        size: 20,
        curr: 1
      },
      dialogComponent: '',
      dialogConfig: {
        show: false,
        title: '',
        fullscreen: false,
        footerHide: false,
        query: '',
        loading: true
      },
      subComponent: '',
      subRouter: {
        query: '',
        show: false
      },
      currentAction: {},
      gridNumber: 3,
      moreFilter: false
    }
  },
  created () {
    const _self = this;
    if (_self.configPath) {
      _self.path = _self.configPath;
    } else {
      _self.path = _self.$route.path.split('/shell/regular/')[1];
    }
    _self.path = _self.path.split('/')[_self.path.split('/').length - 1];
    // 获取当前页面的配置文件
    if (PathConfig[_self.path.toUpperCase() + 'Config']) {
      let config = JSON.stringify(PathConfig[_self.path.toUpperCase() + 'Config']);
      if (_self.defaultQuery && Object.keys(_self.defaultQuery).length > 0) {
        // 如果页面默认属性不为空
        for (let key of Object.keys(_self.defaultQuery)) {
          // 替换配置文件中的默认参数
          config = config.replaceAll('{default.' + key + '}', _self.defaultQuery[key]);
        }
      }
      _self.config = JSON.parse(config);
      _self.getDefaultParam();
      _self.fetchTableList();
    } else {
      _self.config = {
        operList: [],
        queryList: [],
        titles: []
      }
      console.error('标准页面配置文件不存在');
    }
  },
  mounted () {
    this.gridNumber = parseInt(document.getElementsByClassName('left-query')[0].clientWidth / 294)
    window.addEventListener('resize', this.resizeLogic, false);
  },
  watch: {
    // parentId: function (val) {
    //   this.refresh();
    // }
  },
  methods: {
    /**
       * 获取默认查询条件
       **/
    getDefaultParam () {
      const _self = this;
      _self.searchParam = {};
      // 如果prop中有默认参数
      if (_self.defaultQuery) {
        for (let query of _self.config.queryList) {
          if (_self.defaultQuery[query.name]) {
            if (query.component === 'input') {
              query.value = _self.defaultQuery[query.name];
            } else if (query.component === 'multSelect' && query.componentAttr && query.componentAttr.options) {
              query.componentAttr.options.filter(item => _self.defaultQuery[query.name].includes(item.value) && (item.checked = true));
            } else if (query.component === 'select' && query.componentAttr && query.componentAttr.options) {
              query.componentAttr.options.filter(item => _self.defaultQuery[query.name] === item.value ? (item.checked = true) : (delete item.checked));
              query.value = _self.defaultQuery[query.name];
            }
          }
        }
      }
      for (let query of _self.config.queryList) {
        if (query.component === 'input' && query.value) {
          _self.searchParam[query.name] = query.value;
        } else if (query.component === 'multSelect' && query.componentAttr && query.componentAttr.options) {
          _self.searchParam[query.name] = [];
          query.componentAttr.options.filter(item => item.checked && _self.searchParam[query.name].push(item.value));
        } else if (query.component === 'select' && query.componentAttr && query.componentAttr.options) {
          let checkedOne = query.componentAttr.options.filter(item => item.checked);
          if (checkedOne.length > 0) {
            _self.searchParam[query.name] = checkedOne[0].value;
            _self.$set(query, 'value', checkedOne[0].value);
          } else if (undefined !== query.value) {
            _self.searchParam[query.name] = query.value;
          }
        }
      }
    },
    // 获取列表内容
    fetchTableList () {
      const _self = this;
      _self.$Loading.start();
      _self.loading = true;
      _self.tableSelectionIds = []
      let param = {
        query: _self.searchParam,
        page: {
          currPage: _self.page.curr,
          pageSize: _self.page.size
        }
      };
      let url = ''
      let method = 'post';
      if (typeof _self.config.urlMap.select === 'object') {
        url = _self.config.urlMap.select.url;
        if (_self.config.urlMap.select.method) method = _self.config.urlMap.select.method;
        // 原型链 导致
        if (_self.config.urlMap.select.data && typeof _self.config.urlMap.select.data === 'object') {
          let defaultParam = {};
          for (let key of Object.keys(_self.config.urlMap.select.data)) {
            // 替换parentId值
            if (_self.config.urlMap.select.data[key] === '{parentId}') {
              defaultParam[key] = _self.parentId;
              // _self.config.urlMap.select.data[key] = _self.parentId;
            } else {
              defaultParam[key] = _self.config.urlMap.select.data[key];
            }
          }
          // 将默认条件拼接到查询条件记录中
          _self.searchParam = Object.assign({}, defaultParam, _self.searchParam);
          param.query = _self.searchParam;
        }
      } else {
        url = _self.config.urlMap.select;
      }
      _self[method](url, param).then(res => {
        _self.rows = Array.isArray(res.data) ? res.data : (res.data.list || []);
        if (res.data.page) {
          let page = res.data.page;
          _self.page = {
            show: true,
            total: page.totalCount,
            size: page.pageSize,
            curr: page.currPage
          }
        } else {
          _self.page.show = false;
        }
        _self.$Loading.finish();
        _self.loading = false;
      }).catch(() => {
        _self.$Loading.error();
        _self.rows = [];
        _self.page.show = false;
        _self.loading = false;
      });
    },
    // 条件筛选框设置
    setSearchValueChange (curObj) {
      this.searchParam[curObj.name] = curObj.value;
    },
    // 移除条件筛选框
    clearSearchValueChange (curObj) {
      delete this.searchParam[curObj.name];
    },
    enterSearch () {
      this.page = {
        curr: 1,
        size: 20
      };
      this.fetchTableList();
    },
    // 点击功能列表的按钮操作
    clickOperBtn (oper, row) {
      const _self = this;
      if (!oper.action.addr) {
        _self.$Notice.warning({
          title: '警告信息',
          desc: '动作地址未配置，请联系管理员。'
        });
        return;
      }
      // 全局参数替换
      if (oper.action.data) {
        // 替换特殊字符串
        if (oper.action.data === '{searchParam}') {
          oper.action.data = JSON.parse(JSON.stringify(_self.searchParam));
        } else if (oper.action.data === '{parentId}') {
          oper.action.data = _self.parentId;
        } else if (JSON.stringify(oper.action.data).includes('{tableSelectionIds}')) {
          if (!(oper.action.confirm && oper.action.confirm.notSelected) && _self.tableSelectionIds.length === 0) {
            _self.$Notice.warning({
              title: '警告信息',
              desc: '未选择任何项，请至少选择一项再进行操作。'
            });
            return;
          }
          oper.action.data = JSON.parse(JSON.stringify(oper.action.data).replace('{tableSelectionIds}', _self.tableSelectionIds.join(',')));
        } else if (JSON.stringify(oper.action.data).includes('{parentId}')) {
          oper.action.data = JSON.parse(JSON.stringify(oper.action.data).replace('{parentId}', _self.parentId));
        }
      }
      // 替换当前行特殊字符串
      if (row) {
        // 替换参数
        if (_self.config.urlMap[oper.action.addr]) {
          oper.action.addr = _self.config.urlMap[oper.action.addr];
        }
        for (let key of Object.keys(row)) {
          // 替换路径中的变量和参数中的变量
          oper.action.addr = oper.action.addr.replace('{' + key + '}', row[key]);
          if (oper.action.data) {
            oper.action.data = JSON.parse(JSON.stringify(oper.action.data).replace('{' + key + '}', row[key]));
          }
        }
      }
      if (oper.action.data) {
        // 将data中的表达式转化为结果
        if (typeof oper.action.data === 'string') {
          if (oper.action.data.includes('(')) {
            oper.action.data = _self.evil(oper.action.data);
          }
        } else {
          for (let key of Object.keys(oper.action.data)) {
            if (typeof oper.action.data[key] === 'string') {
              if (oper.action.data[key].includes('(')) {
                oper.action.data[key] = _self.evil(oper.action.data[key]);
              } else if (oper.action.data[key] === '{searchParam}') {
                oper.action.data[key] = JSON.parse(JSON.stringify(_self.searchParam));
              } else if (oper.action.data[key] === '{parentId}') {
                oper.action.data[key] = _self.parentId;
              }
            }
          }
        }
      }
      // 替换特殊字符串
      if (oper.action.addr.includes('{tableSelectionIds}')) {
        if (!(oper.action.confirm && oper.action.confirm.notSelected) && _self.tableSelectionIds.length === 0) {
          _self.$Notice.warning({
            title: '警告信息',
            desc: '未选择任何项，请至少选择一项再进行操作。'
          });
          return;
        }
        oper.action.addr = oper.action.addr.replace('{tableSelectionIds}', _self.tableSelectionIds.join(','));
      }

      if (oper.action.addr.includes('{')) {
        _self.$Notice.warning({
          title: '警告信息',
          desc: '操作需要的数据未提供。'
        });
        return;
      }
      _self.currentAction = oper.action;
      if (oper.action && oper.action.confirm && oper.action.confirm.desc) {
        _self.$Modal.confirm({
          title: '提示',
          width: 340,
          content: oper.action.confirm.desc,
          onOk: function () {
            if (oper.action.type === 'dialog') {
              _self.openDynamicDialog(oper.action.addr, oper.action.title || oper.label, {
                fullscreen: oper.action.fullscreen,
                footerHide: oper.action.footerHide,
                width: oper.action.width
              });
            } else if (oper.action.type === 'request') {
              // console.log('request:' + oper.action.addr);
              _self.execRequestAction(oper.action.method, _self.config.urlMap[oper.action.addr] ? _self.config.urlMap[oper.action.addr] : oper.action.addr, oper.action.data ? oper.action.data : {});
            } else if (oper.action.type === 'func') {
              _self[oper.action.addr](oper.action.data || {}, oper.name);
            } else if (oper.action.type === 'router') {
              _self.$router.push({path: oper.action.addr});
            } else if (oper.action.type === 'subRouter') {
              _self.openDynamicSub(oper.addr || oper.action.addr);
            } else if (oper.action.type === 'url') {
              setTimeout(function () {
                window.open(_self.currentAction.addr)
              }, 500);
            }
          },
          onCancel: function () {
            console.log('取消', oper);
          }
        })
      } else if (oper.action) {
        if (oper.action.type === 'dialog') {
          _self.openDynamicDialog(oper.action.addr, oper.action.title || oper.label, {
            fullscreen: oper.action.fullscreen,
            footerHide: oper.action.footerHide,
            width: oper.action.width
          });
        } else if (oper.action.type === 'request') {
          // console.log('request:' + oper.action.addr);
          _self.execRequestAction(oper.action.method, _self.config.urlMap[oper.action.addr] ? _self.config.urlMap[oper.action.addr] : oper.action.addr, oper.action.data ? oper.action.data : {});
        } else if (oper.action.type === 'func') {
          _self[oper.action.addr](oper.action.data || {}, oper.name);
        } else if (oper.action.type === 'router') {
          this.$router.push({path: oper.action.addr});
        } else if (oper.action.type === 'subRouter') {
          _self.openDynamicSub(oper.addr || oper.action.addr);
        } else if (oper.action.type === 'url') {
          setTimeout(function () {
            window.open(_self.currentAction.addr)
          }, 500);
        }
      }
    },
    // 打开动态加载的弹窗
    /**
       * 打开动态弹窗
       * @param addr 弹窗相对路径
       * @param label 弹窗标题
       * @param config 弹窗的配置属性
       * {
       *    fullscreen 弹窗大小，true：全屏
       *    footerHide 是否隐藏底部确认按钮
       *    width 弹窗宽度
       * }
       */
    openDynamicDialog (addr, label, config) {
      const _self = this;
      let componentName = 'dialog' + '_' + addr.split('?')[0].replace(/\//g, '_');
      Vue.component(componentName, Vue.extend(importDialogCustom(addr.split('?')[0])));
      _self.dialogComponent = componentName;
      _self.dialogConfig.query = addr.split('?')[1] || '';
      _self.dialogConfig.title = label;
      _self.dialogConfig.fullscreen = config.fullscreen || false;
      _self.dialogConfig.footerHide = config.footerHide || false;
      _self.dialogConfig.width = config.width || '520'
      _self.dialogConfig.loading = true;
      _self.dialogConfig.show = true;
    },
    // 打开子页面
    openDynamicSub (addr) {
      const _self = this;
      let componentName = 'subRouter' + '_' + addr.split('?')[0].replace(/\//g, '_');
      Vue.component(componentName, Vue.extend(importSubCustom(addr.split('?')[0])));
      _self.subComponent = componentName;
      _self.subRouter.query = addr.split('?')[1] || '';
      _self.subRouter.show = true;
    },
    backMain () {
      this.subRouter.show = false;
      this.fetchTableList();
    },
    // 弹窗操作成功，手动关闭并重新加载列表
    reload () {
      const _self = this;
      _self.dialogConfig.show = false;
      _self.fetchTableList();
      _self.$emit('reload');
    },
    // 定制弹窗点击确定按钮
    dialogOK () {
      const _self = this;
      _self.$refs[_self.dialogComponent].dialogComfirm().then(val => {
        // 确定成功后重刷页面
        _self.dialogConfig.show = false;
        if (_self.currentAction.nextAction) {
          _self.execNextAction(_self.currentAction.nextAction);
        } else {
          _self.fetchTableList();
          _self.$emit('reload');
        }
      }).catch(() => {
        _self.dialogConfig.loading = false;
        _self.$nextTick(function () {
          _self.dialogConfig.loading = true;
        })
      });
    },
    /**
       * 执行请求
       * @param method 请求方式，默认post
       * @param url 接口
       * @param params 请求参数
       **/
    execRequestAction (method, url, params) {
      const _self = this;
      this[method || 'post'](url, params).then(res => {
        if (_self.currentAction.nextAction) {
          if (_self.currentAction.refresh) {
            this.fetchTableList();
            this.$emit('reload');
          }
          _self.execNextAction(_self.currentAction.nextAction, res);
        } else {
          // 默认成功后重刷页面
          this.$Message.success(res.msg);
          this.fetchTableList();
          this.$emit('reload');
        }
      }).catch(err => {
        if (_self.currentAction.errorNextAction) {
          _self.execNextAction(_self.currentAction.errorNextAction, err);
        }
      });
    },
    execNextAction (actionName, result) {
      const _self = this;
      _self.currentAction = _self.config.operList.filter(item => item.name === actionName);
      if (_self.currentAction.length > 0) {
        _self.currentAction = _self.currentAction[0];
        for (let key of Object.keys(result)) {
          _self.currentAction = JSON.parse(JSON.stringify(_self.currentAction).replace('{' + key + '}', result[key]));
        }
        _self.clickOperBtn(_self.currentAction);
      } else {
        _self.currentAction = null;
        this.$Message.error(`下一步动作${actionName}未找到`);
      }
    },
    /**
       * 表格组件总的分页操作
       * @param page
       * @param size
       */
    changePage (page, size) {
      this.page = Object.assign(this.page, {
        curr: page,
        size: size
      })
      this.fetchTableList();
    },
    // 获取列表选中的id
    handleTableSelect (selectionIds) {
      this.tableSelectionIds = selectionIds;
    },
    // 刷新页面
    refresh () {
      const _self = this;
      if (PathConfig[_self.path.toUpperCase() + 'Config']) {
        let config = JSON.stringify(PathConfig[_self.path.toUpperCase() + 'Config']);
        if (_self.defaultQuery && Object.keys(_self.defaultQuery).length > 0) {
          // 如果页面默认属性不为空
          for (let key of Object.keys(_self.defaultQuery)) {
            // 替换配置文件中的默认参数
            config = config.replaceAll('{default.' + key + '}', _self.defaultQuery[key]);
          }
        }
        _self.config = JSON.parse(config);
        _self.getDefaultParam();
        _self.fetchTableList();
      }
    },
    // 纪律选中的项，并跳转到相应的界面上，
    // 解决url超出最长限制的问题
    recordSelectedAndJump (param, name) {
      const _self = this;
      if (!(_self.currentAction.confirm && _self.currentAction.confirm.notSelected) && _self.tableSelectionIds.length === 0) {
        _self.$Notice.warning({
          title: '警告信息',
          desc: '未选择任何项，请至少选择一项再进行操作。'
        });
        return;
      }
      sessionStorage.setItem(param.name || 'tableSelectionIds', this.tableSelectionIds.join(','));
      _self.openDynamicSub(param.addr);
      // _self.$router.push({path: _self.$route.path, query: {oper: name}});
      // this.$router.push({path: param.addr});
    },
    // 显示header中的个人信息页
    showUserMsg () {
      this.$store.state.headerUserMsgFlag = true;
    },
    // 模拟eval
    evil (fn) {
      if (fn) {
        let Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
        return new Fn('return ' + fn)();
      } else {
        return true;
      }
    },
    resizeLogic () {
      this.gridNumber = parseInt(document.getElementsByClassName('left-query')[0].clientWidth / 294)
    }
  },
  activated () {
    // 激活配置了刷新数据属性
    if (this.config.tableConfig && this.config.tableConfig.activatedRefresh) {
      // 当前为子页面
      if (this.subRouter.show) {
        // 返回主页列表
        this.backMain();
      } else {
        this.fetchTableList();
      }
    }
  },
  destroy () {
    window.removeEventListener('resize', this.resizeLogic);
  }
}
</script>

<style lang="less">
  .kh-table-border td, .kh-table-border th {
    border-left: 1px solid #e8eaec;
  }

  .regular-list {
  }

  .kh-table-border:before {
    height: 0 !important;
  }

  .kh-table-border:after {
    height: 0 !important;
  }

  .m-background {
    background-color: #fff;
    border-radius: 4px;
    width: calc(100% - 20px);
    margin-left: 10px;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/regularPage/index.vue